import React, { useEffect } from 'react';
import * as Api from '../lib/api';

const ChatBitrix24 = () => {
    const initChat = config => {
        const { id, hash, name, lastName, avatar, email } = config;

        window.addEventListener('onBitrixLiveChat', function (event) {
            var widget = event.detail.widget;

            // Setting external user authentication
            widget.setUserRegisterData({
                hash,
                name,
                lastName,
                avatar,
                email,
                www: window.location.hostname,
                gender: '',
                position: 'Клиент',
            });

            widget.setCustomData([
                {
                    USER: {
                        NAME: name,
                        AVATAR: avatar,
                    },
                },
                {
                    GRID: [
                        {
                            NAME: 'E-mail',
                            VALUE: email,
                            DISPLAY: 'LINE',
                        },
                        {
                            NAME: 'Customer ID',
                            VALUE: id,
                            COLOR: '#ff0000',
                            DISPLAY: 'LINE',
                        },
                        {
                            NAME: 'Website',
                            VALUE: window.location.hostname,
                            DISPLAY: 'LINE',
                        },
                        {
                            NAME: 'Page',
                            VALUE: '' + (document.title || window.location.href) + '',
                            DISPLAY: 'LINE',
                        },
                    ],
                },
            ]);

            widget.subscribe({
                type: window.BX.LiveChatWidget.SubscriptionType.every,
                callback: function (event) {
                    // if (event.type === window.BX.LiveChatWidget.SubscriptionType.configLoaded) {
                    //     widget.open();
                    // }
                },
            });
        });

        (function (w, d, u) {
            var s = d.createElement('script');
            s.async = true;
            s.src = u + '?' + ((Date.now() / 60000) | 0);
            var h = d.getElementsByTagName('script')[0];
            h.parentNode.insertBefore(s, h);
        })(window, document, 'https://arlift.net/upload/crm/site_button/loader_3_cdel5i.js');
    };

    useEffect(() => {
        Api.fetch('chat/data').then(response => {
            if (response.success) {
                initChat(response.result);
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div></div>;
};

export default ChatBitrix24;
